import React from 'react';
import { withTranslation } from 'react-i18next';
import { formatData, isNullOrEmpty, translate } from '../../../../utils/util';

const ListCimFileItem = (props) => {
    const { item } = props;

    const formatMessageErro = () => {
        try {
            if (!isNullOrEmpty(item.jsonResponse) && !item?.success) {
                var dataResponse = JSON.parse(item.jsonResponse);
                return (<div className="col s12 list sixth-text-color" style={{ display: 'block', color: 'black' }}>
                    {dataResponse.DETALHES}
                </div>)
            }
        } catch {
            return item.jsonResponse;
        }
    }

    return (
        <div
            className="row"
            style={{ color: 'black', display: 'block', marginBottom: '0px', marginLeft: '0px' }}
            key={`oi-${item.id}`}
            onClick={()=>props.onSelectChange(item)}
        >
            <div className="title black-text col s12" style={{ paddingLeft: '7px' }}>
                {item.fileName}
            </div>
            <div className="col s12 " style={{ display: 'block' }}>
                {formatData(item?.createdOn || '')}
            </div>
            <div className="col s12 " style={{ display: 'block' }}>
                {item.createdByDesc}
            </div>
            {
                !item?.fileCreated &&
                <>
                    {
                        !isNullOrEmpty(item.expeditionCode) &&
                        <div className="col s12" style={{ display: 'block' }}>
                            {translate('menu:picking')} - {item.expeditionCode}
                        </div>
                    }
                    <div className="col s12 list sixth-text" style={{ display: 'block', color: (item?.success ? 'black' : 'red') }}>
                        {item?.success ? translate('general:success') : translate('general:erro')}
                    </div>
                    {formatMessageErro()}
                </>
            }
            {
                item?.fileCreated &&
                <span
                    className="list sixth-text-color right"
                    style={{ position: 'absolute', marginTop: '0px', right: '10px', zIndex: '999' }}
                    onClick={() => props.onClickDownload(item)}
                >
                    <i className={`mdi mdi-36px mdi-download`} />
                </span>
            }
        </div >
    );
}

export default (withTranslation()(ListCimFileItem))